import React from 'react';
import RemainingTimeBreakdownPopover from './RemainingTimeBreakdownPopover';
import { buildRemainingTimeLabel } from '../utils/buildCampaignStatsText';

/**
 * Shared meta line: task completion counts, optional progress %, remaining time.
 */
const CampaignProgressMeta = ({
  completedCount,
  totalCount,
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
  remainingBreakdown = [],
  progressPercent,
  includeProgressPercent = false,
  className,
  countClassName,
}) => {
  const hasIncompleteWork = completedCount < totalCount;
  const prefixParts = [`${completedCount} / ${totalCount} complete`];

  if (includeProgressPercent && progressPercent != null) {
    prefixParts.push(`${progressPercent}%`);
  }

  const remainingLabel = buildRemainingTimeLabel({
    remainingMinutes,
    remainingMinMinutes,
    missingEstCount,
  });

  return (
    <div className={className}>
      <span className={countClassName}>
        {prefixParts.join(' • ')}
        {hasIncompleteWork && (
          <>
            {' • '}
            <RemainingTimeBreakdownPopover
              remainingMinutes={remainingMinutes}
              remainingMinMinutes={remainingMinMinutes}
              missingEstCount={missingEstCount}
              breakdown={remainingBreakdown}
              label={remainingLabel}
            />
          </>
        )}
      </span>
    </div>
  );
};

export default CampaignProgressMeta;
